export * from "state/teachers/selectors/schools";
export * from "state/teachers/selectors/messages";
export * from "state/teachers/selectors/notices";
export * from "state/teachers/selectors/terms";

export function getGuideShownDate(state) {
  return state.getIn(["teachers", "guideShownDate"]);
}

export function isGuideOpen(state) {
  return state.getIn(["teachers", "isGuideOpen"]);
}



// WEBPACK FOOTER //
// ./src/state/teachers/selectors/index.js